import React from 'react';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';

interface MobilePaginationProps {
  total: number;
  selected: number;
  loading: boolean;
  currentPage: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
  onSortChange: (sort: string) => void;
  sortOptions?: { value: string; label: string }[];
  defaultSort?: string;
}

export default function MobilePagination({
  total,
  selected,
  loading,
  currentPage,
  limit,
  onPageChange,
  onLimitChange,
  onSortChange,
  sortOptions = [
    { value: 'id:ASC', label: 'Old to New' },
    { value: 'id:DESC', label: 'New to Old' },
    { value: 'updated_at:DESC', label: 'Last Update' },
  ],
  defaultSort = 'id:ASC',
}: MobilePaginationProps) {
  return (
    <div className="flex flex-col items-center my-4">
      <div className="hidden md:flex justify-between items-center w-full px-6">
        <Typography variant="h6">Total: {total}</Typography>
        <Typography variant="h6">Selected: {selected}</Typography>
        <div className="flex items-center">
          <label htmlFor="limit" className="mr-2">
            Set limit:
          </label>
          <select
            disabled={loading}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            value={limit}
            className="cursor-pointer p-1 mr-4 border border-gray-300 rounded"
          >
            <option value={10}>10</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={250}>250</option>
            <option value={500}>500</option>
          </select>
        </div>
        <div className="flex items-center">
          <label htmlFor="sort" className="mr-2">
            Sort by:
          </label>
          <select
            disabled={loading}
            onChange={(e) => onSortChange(e.target.value)}
            defaultValue={defaultSort}
            className="cursor-pointer p-1 mr-4 border border-gray-300 rounded"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <Pagination
          disabled={loading}
          color="primary"
          count={Math.ceil(total / limit)}
          page={currentPage}
          onChange={(e, page) => onPageChange(page)}
        />
      </div>
      <div className="flex flex-col items-center md:hidden">
        <div className="flex justify-between w-full mb-2">
          <Typography variant="button">Total: {total}</Typography>
          <Typography variant="button">Selected: {selected}</Typography>
        </div>
        <Pagination
          disabled={loading}
          color="primary"
          count={Math.ceil(total / limit)}
          page={currentPage}
          onChange={(e, page) => onPageChange(page)}
        />
        <div className="flex justify-center items-center mt-4">
          <div className="mr-4">
            <label htmlFor="limit">Set limit: </label>
            <select
              disabled={loading}
              onChange={(e) => onLimitChange(Number(e.target.value))}
              value={limit}
              className="cursor-pointer p-1 border border-gray-300 rounded"
            >
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
            </select>
          </div>
          <div>
            <label htmlFor="sort">Sort by: </label>
            <select
              disabled={loading}
              onChange={(e) => onSortChange(e.target.value)}
              defaultValue={defaultSort}
              className="cursor-pointer p-1 border border-gray-300 rounded"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
